<script>
import SummerCampSearchFiltersContainer from './SummerCampSearchFiltersContainer'
import SummerCampSearchBar from './SummerCampSearchBar'
import {Form} from '../../helpers/Form/Form'
import {queryString} from '../../mixins/querystring'

export default {
  mixins: [queryString],
  components: {SummerCampSearchFiltersContainer, SummerCampSearchBar},
  data() {
    return {
      isLoading: false,
      items: [],
      pagination: {},
      form: new Form({
        latitude: 0,
        longitude: 0,
        sport: null,
        municipality: null,
        languages: [],
        locations: [],
        modalities: [],
        countries: [],
        months: [],
        age: null,
        disabilities: [],
        page: 1
      }),
      search_string: '',
      search_string_label: '',
      tags: [],
      filteredSummerCamps: [],
      sportsSelected: [],
      mobileDetect: window.innerWidth < 500,
      languages: [],
      disabilities: [],
      modalities: [],
      countries: [],
      locations: [
          'Montagna',
          'Mare',
          'Natura',
          'Città'
      ]
    }
  },
  computed: {
    hiddenLoadMore() {
      return !this.filteredSummerCamps || this.filteredSummerCamps.length == 0;
    },
    hasMoreResults() {
      return this.pagination.current_page < this.pagination.last_page
    },
    searchLabel() {
      let label = ''

      if (!_.isEmpty(this.form.sport)) {
        label += `${this.form.sport} `
      }
      if (!_.isEmpty(this.form.municipality)) {
        label += `${this.form.municipality}`
      }
      if (label.length > 0) {
        return label += ':'
      }
      return null
    }
  },
  async mounted() {
    /*$(window.document).on('click', '.results-body__filters .dropdown-item', function(event){
      const events = $._data(document, 'events') || {};
      const eventsClick = events.click || [];
      for(var i = 0; i < eventsClick.length; i++) {
        if(eventsClick[i].selector) {
          //Check if the clicked element matches the event selector
          if($(event.target).is(eventsClick[i].selector)) {
            eventsClick[i].handler.call(event.target, event);
          }

          // Check if any of the clicked element parents matches the 
          // delegated event selector (Emulating propagation)
          $(event.target).parents(eventsClick[i].selector).each(function(){
            eventsClick[i].handler.call(this, event);
          });
        }
      }
      
      event.stopPropagation(); //Always stop propagation
    });*/

    window.onscroll = function () {
      if (window.isMobile()) {
        if (window.pageYOffset > 60) {
          $('.summer-camps__btn').removeClass('d-none')
          $('.navbar-brand__logo').hide()
        } else {
          $('.summer-camps__btn').addClass('d-none')
          $('.navbar-brand__logo').show()
        }
      }
    }

    window.onresize = () => {
      console.log(window.innerWidth)
      this.$set(this, 'mobileDetect', window.innerWidth < 500)
    }

    await this.getDisabilities()
    await this.getModalities()
    await this.getCountries()
    await this.getLanguages()
  },
  methods: {
    async getModalities() {
     axios({
          method: 'get',
          url: '/modalities'
      }).then(({data}) => {
          this.$set(this, 'modalities', data.modalities)
      }).catch((error) => {
          //
      })
  },
  async getLanguages() {
      axios({
          method: 'get',
          url: route('summer-camps.languages.index')
      }).then(({data}) => {
        this.$set(this, 'languages', Object.values(data.languages))
        console.log(data)
      }).catch((error) => {
          //
      })
  },
  async getCountries() {
      axios({
          method: 'get',
          url: route('summer_camps.countries')
      }).then(({data}) => {
          this.$set(this, 'countries', data.countries)
      }).catch((error) => {
          //
      })
  },
  async getDisabilities() {
      axios({
          method: 'get',
          url: '/disabilities'
      }).then(({data}) => {
          this.$set(this, 'disabilities', data.disabilities)
      }).catch((error) => {
          //
      })
  },
    updateFormData() {
      let params = this.getAllUrlParams()

      for (let prop in params) {
        if (!_.isEmpty(params[prop]) || !_.isUndefined(params[prop])) {
          if (this.form.hasOwnProperty(prop)) {
            this.$set(this.form, prop, params[prop])
          }
        }
      }
    },
    openFiltersModal() {
      $('#summerCampFilters').modal({
        backdrop: 'static',
        keyboard: false
      })
    },
    updateFilters(filters) {
      for (let prop in filters) {
        if (this.form.hasOwnProperty(prop)) {
          this.$set(this.form, prop, filters[prop])
        }
      }

      this.$set(this, 'items', [])
      this.$set(this, 'pagination', {})
      this.$set(this.form, 'page', 1)

      let source = route('summer-camps.show')
      let queryString = []
      let data = this.form.data()

      for (let prop in data) {
        if (_.isArray(data[prop])) {
          if (!_.isEmpty(data[prop])) {
            data[prop].forEach(value => {
              queryString.push(`${prop}[]=${value}`)
            })
          }
        } else {
          if (!_.isNull(data[prop])) {
            queryString.push(`${prop}=${data[prop]}`)
          }
        }
      }

      window.history.pushState({
        path: `${source}?${queryString.join('&')}`
      }, '', `${source}?${queryString.join('&')}`)

      this.fetchSummerCamps()
    },
    onSearch() {
      this.$set(this.form, 'page', 1)

      let data = this.form.data()
      let queryString = Object.keys(data).map(key => key + '=' + data[key]).join('&');
      let source = route('summer-camps.home')
      location.href = `${source}?${queryString}`
    },
    fetchSummerCamps() {
      this.$set(this,'isLoading', true)
      
      this.form
          .get(route('summer_camps.index'), {}, true)
          .then(({summerCamps}) => {
            this.$set(this,'isLoading', false)

            const obj_pagination = _.omit(summerCamps, ['data'])
            // console.log(obj_pagination)

            let items = this.items
            this.$set(this.form, 'page', summerCamps.current_page + 1)
            this.$set(this, 'pagination', obj_pagination)
            this.$set(this, 'items', items.concat(summerCamps.data))
          })
          .catch((error) => {
            this.$set(this,'isLoading', false)
          }) 
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/summer-camps/SummerCampSearchViewContainer.vue